module.exports = __webpack_public_path__ + "static/logo.d27a46fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = 1089
// module chunks = 168707334958949